import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async"; // Corrected import for meta tags
import NavBar from "../Navigation/NavBar";
import Benner from "./Benner";
import Services from "./Services/Services";
import Industrie from "./Industrie/Industrie";
import WhyChoose from "./WhyChoose/WhyChoose";
import ClientsAndCandidates from "./ClientsAndCandidates/ClientsAndCandidates";
import OurProcess from "./OurProcess/OurProcess";
import Testimonials from "../Testimonials/Testimonials";
import GetInTouch from "../GetInTouch/GetInTouch";
import Footer from "../Footer/Footer";
import WhatsAppWidgetComponent from "../Whatsapp/WhatsAppWidgetComponent";

function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {/* Use Helmet for meta tags in React */}
      <Helmet>
        <title>Quarec Resources Pvt. Ltd. – Expert HR Consultancy &amp; Placement Services</title>
        <meta
          name="description"
          content="Specializing in HR solutions, Quarec Resources Pvt. Ltd. connects career seekers with employers, delivering quality manpower across various industries."
        />
        <meta name="keywords" content="HR solutions, placement services, recruitment, Quarec Resources" />
        <meta name="author" content="Quarec Resources" />
      </Helmet>

      <NavBar />
      <Benner />
      <Services />
      <Industrie />
      {/* <WhyChoose /> */}
      <ClientsAndCandidates />
      <OurProcess />
      <Testimonials />
      <GetInTouch />
      <Footer />
      <WhatsAppWidgetComponent />
    </>
  );
}

export default Home;
